<div class="gantt-empty" *ngIf="!rows.length && !bands.length">Todavía no hay trabajo con fechas: no hay duraciones que graficar.</div>

<div class="gantt" *ngIf="rows.length || bands.length">
  <div class="g-scroll">
    <div class="g-inner" [style.min-width.px]="trackWidth + 260">
      <!-- Cabecera: meses -->
      <div class="g-head">
        <div class="g-head-label">
          <i class="fa-solid fa-layer-group"></i> {{ loose === null ? 'Épica' : 'Implementación' }}
        </div>
        <div class="g-track">
          <div class="g-month" *ngFor="let m of months" [class.current]="m.isCurrent"
            [style.left.%]="m.left" [style.width.%]="m.width">{{ m.label }}</div>
        </div>
      </div>

      <!-- Filas -->
      <div class="g-body">
        <!-- Capa del marcador HOY: se ancla al carril, no a la fila, para cruzar todas las barras. -->
        <div class="g-today-layer" *ngIf="todayLeft !== null" aria-hidden="true">
          <span class="g-today" [style.left.%]="todayLeft"><span class="g-today-lbl">HOY</span></span>
        </div>

        <!-- Sin carril suelto: la lista plana de épicas, exactamente como estaba. -->
        <ng-container *ngIf="loose === null">
          <ng-container *ngFor="let r of rows; trackBy: trackEpic">
            <ng-container *ngTemplateOutlet="epicRow; context: { $implicit: r }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Con carril suelto: tres bandas. Lo que corre, lo entregado y lo comprometido sin arrancar. -->
        <ng-container *ngIf="loose !== null">
          <ng-container *ngFor="let b of bands">
            <div class="g-band">
              <div class="g-band-label"><i [class]="b.icon"></i> {{ b.label }}</div>
              <div class="g-track"></div>
            </div>

            <ng-container *ngFor="let r of b.epics; trackBy: trackEpic">
              <ng-container *ngTemplateOutlet="epicRow; context: { $implicit: r }"></ng-container>
            </ng-container>

            <!-- Tarea o bug de una sola pieza: sin desglose que abrir, con su etapa a la vista. -->
            <div class="g-row g-row-loose" *ngFor="let l of b.loose; trackBy: trackLoose">
              <div class="g-label">
                <i class="g-type" [class]="l.typeIcon" [style.color]="l.typeColor" [title]="l.item.type"></i>
                <span class="g-label-text" (click)="onPickLoose(l)" role="button" tabindex="0" (keydown.enter)="onPickLoose(l)">
                  <span class="g-title" [title]="l.item.title">
                    <span class="g-code" *ngIf="l.item.code">{{ l.item.code }}</span>{{ l.item.title }}
                  </span>
                  <span class="g-sub">
                    <ng-container *ngIf="l.stageLabel; else soloDuracion">
                      <span class="g-dot" [style.background]="l.stageColor"></span>
                      {{ l.stageLabel }} · paso {{ l.stageStep }}/{{ TOTAL_STAGES }}
                    </ng-container>
                    <ng-template #soloDuracion>{{ l.durationLabel }}</ng-template>
                    <span class="g-pts" *ngIf="l.item.points">· {{ l.item.points }} pts</span>
                  </span>
                </span>
              </div>

              <div class="g-track">
                <!-- Sin recorrido medido no se finge una barra: rombo en la fecha que sí se conoce. -->
                <span class="g-point" *ngIf="l.point" [style.left.%]="l.left" [style.background]="l.color"
                  [title]="l.tooltip + ' · sin duración medida'"></span>
                <div class="g-lbar" *ngIf="!l.point" [style.left.%]="l.left" [style.width.%]="l.width"
                  [style.background-color]="l.color"
                  (click)="onPickLoose(l)" role="button" tabindex="0" (keydown.enter)="onPickLoose(l)"
                  [title]="l.tooltip + ' · ' + l.durationLabel">
                  <span class="g-dev" [style.width.%]="l.devWidth" [style.background]="l.color"></span>
                </div>
                <!-- El atraso como geometría: de la fecha comprometida a hoy. -->
                <div class="g-overdue" *ngIf="l.overdueLeft !== null" [style.left.%]="l.overdueLeft" [style.width.%]="l.overdueWidth"
                  title="Pasada la fecha comprometida"></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Las épicas sin trabajo no se dibujan —no tienen duración— pero se pueden ABRIR. Antes solo se
       contaban, y una épica registrada de más no aparecía en ninguna otra pantalla: quedaba fuera de
       alcance para siempre (F-037). -->
  <div class="g-foot g-sinwork" *ngIf="sinTrabajo.length">
    <span class="g-sinwork-lbl">
      <i class="fa-solid fa-circle-info"></i>
      {{ sinTrabajo.length }} épica{{ sinTrabajo.length === 1 ? '' : 's' }} sin trabajo cargado no
      aparece{{ sinTrabajo.length === 1 ? '' : 'n' }} en el carril: todavía no tienen duración.
    </span>
    <span class="g-sinwork-chips">
      <button type="button" class="g-sinwork-chip" *ngFor="let e of sinTrabajo" (click)="select.emit(e)"
        [title]="'Abrir ' + e.epic.title">
        <i class="fa-solid fa-layer-group"></i> {{ e.epic.title }}
      </button>
    </span>
  </div>
  <!-- Lo que llegó y no se dibujó se declara: omitirlo en silencio haría leer el carril como si
       fuera todo el trabajo suelto. -->
  <p class="g-foot" *ngIf="undrawnLoose">
    <i class="fa-solid fa-circle-info"></i>
    {{ undrawnLoose }} tarea{{ undrawnLoose === 1 ? '' : 's' }} en cola sin fecha comprometida tampoco aparece{{ undrawnLoose === 1 ? '' : 'n' }}: no hay nada que anticipar.
  </p>
</div>

<!-- La fila de una épica, intacta: se reutiliza tal cual con y sin bandas. -->
<ng-template #epicRow let-r>
          <div class="g-row" [class.is-open]="r.expanded">
            <div class="g-label">
              <button type="button" class="g-toggle" (click)="toggle(r)"
                [attr.aria-expanded]="r.expanded" [attr.aria-label]="(r.expanded ? 'Ocultar' : 'Ver') + ' las tareas de ' + r.epic.epic.title">
                <i class="fa-solid" [ngClass]="r.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              </button>
              <span class="g-label-text" (click)="onPick(r)" role="button" tabindex="0" (keydown.enter)="onPick(r)">
                <span class="g-title" [title]="r.epic.epic.title">{{ r.epic.epic.title }}</span>
                <span class="g-sub">
                  <span class="g-dot" [style.background]="r.statusColor" [title]="r.statusLabel"></span>
                  {{ r.epic.doneCount }}/{{ r.epic.taskCount }} tareas
                  <span class="g-pts" *ngIf="r.epic.points">· {{ r.epic.points }} pts</span>
                </span>
              </span>
            </div>

            <div class="g-track">
              <!-- La pista pálida es la ENVOLVENTE (cuándo estuvo abierta); los tramos sólidos son
                   el trabajo real. Los huecos entre tramos son los días que nadie la tocó, y son
                   justo lo que la barra maciza anterior escondía detrás de un "42 d". -->
              <div class="g-bar" [class.is-narrow]="r.width < 3" [style.left.%]="r.left" [style.width.%]="r.width"
                (click)="onPick(r)" role="button" tabindex="0" (keydown.enter)="onPick(r)"
                [title]="r.epic.epic.title + ' · ' + r.statusLabel + ' · ' + r.rangeLabel + ' · trabajo ' + r.durationLabel + (r.elapsedLabel ? ' · abierta ' + r.elapsedLabel : '')">
                <span class="g-seg" *ngFor="let sg of r.segments" [class.is-open]="sg.open"
                  [style.left.%]="sg.left" [style.width.%]="sg.width" [style.background]="EPIC_BAR_COLOR"></span>
                <span class="g-bar-txt">
                  {{ r.durationLabel }}<span class="g-bar-open" *ngIf="r.elapsedLabel"> · abierta {{ r.elapsedLabel }}</span>
                </span>
              </div>
            </div>
          </div>

          <!-- Desglose: las tareas que compusieron la épica -->
          <ng-container *ngIf="r.expanded">
            <div class="g-row g-row-child g-loading" *ngIf="r.loading">
              <div class="g-label"><span class="g-child-title">Cargando tareas…</span></div>
              <div class="g-track"></div>
            </div>

            <div class="g-row g-row-child" *ngFor="let t of r.tasks">
              <div class="g-label">
                <!-- La tarea del desglose ES una tarea: se abre igual que la del carril suelto.
                     Que no se pudiera era una inconsistencia, no una decisión: el desglose ya
                     traía su `_id`. -->
                <span class="g-child-title is-clickable" [title]="t.task.title"
                  (click)="onPickTask(t)" role="button" tabindex="0" (keydown.enter)="onPickTask(t)">
                  <span class="g-code" *ngIf="t.task.code">{{ t.task.code }}</span>{{ t.task.title }}
                </span>
              </div>
              <div class="g-track">
                <span class="g-point" *ngIf="t.point" [style.left.%]="t.left" [style.background]="t.color" [title]="t.tooltip + ' · sin fecha de inicio'"></span>
                <!-- Lo sólido es desarrollo; la cola rayada, la espera de ventana de liberación. -->
                <div class="g-tbar" *ngIf="!t.point" [style.left.%]="t.left" [style.width.%]="t.width"
                  [style.background-color]="t.color" [title]="t.tooltip"
                  (click)="onPickTask(t)" role="button" tabindex="0" (keydown.enter)="onPickTask(t)">
                  <span class="g-dev" [style.width.%]="t.devWidth" [style.background]="t.color"></span>
                </div>
              </div>
            </div>

            <div class="g-row g-row-child g-empty-child" *ngIf="r.tasks && !r.tasks.length">
              <div class="g-label"><span class="g-child-title">Sin tareas vinculadas.</span></div>
              <div class="g-track"></div>
            </div>
          </ng-container>
</ng-template>
